import { ProfilePicture } from '../../../../../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import { CaptionText, H3 } from '../../../../../../styles/FontStyles';
import {
  Flexed,
  UserImageCircle
} from '../../../../../../styles/GlobalComponents';
import { color } from '../../../../../../styles/GlobalStyles';

export const UserProfile = ({ teamMember }) => {
  const { t } = useTranslation('myTeam');

  return (
    <Flexed center column>
      <ProfilePicture
        size={'100px'}
        style={{ marginBottom: 12, marginRight: 0 }}>
        <UserImageCircle
          image={teamMember?.profileImageUrl}
          avatar
          avatarSize='40px'
          size='100px'
        />
      </ProfilePicture>

      <CaptionText center color={color.colors.neutral900}>
        {t('id')}: {teamMember?.id}
      </CaptionText>

      <H3
        center
        mb='10'
        color={color.colors.neutral900}
        style={{ maxWidth: '100%' }}>
        <div className='truncated'>
          <div>{teamMember?.username}</div>
        </div>
      </H3>
    </Flexed>
  );
};
